import React from 'react';
import styled from 'styled-components';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import gql from 'graphql-tag';
import { useQuery, useMutation } from '@apollo/react-hooks';

import Block from 'components/common/block';
import { ReactComponent as TrashIcon } from 'assets/vectors/remove-16px.svg';
import { ReactComponent as AddIcon } from 'assets/vectors/add-green-16px.svg';
import { ReactComponent as STSBoxIcon } from 'assets/vectors/stsBoxIcon.svg';

import StsBoxesModal from './stsBoxesModal';

const ArchiveStsProjectEquipment = gql`
  mutation ArchiveStsProjectEquipment($input: ArchiveStsProjectEquipmentInput!) {
    archiveStsProjectEquipment(archiveStsProjectEquipmentData: $input) {
      success
    }
  }
`;

const GetStsBoxes = gql`
  query StsProjectEquipments ($sortBy: [String], $stsprojectId: ID){
    stsprojectEquipments(sortBy: $sortBy, stsprojectId: $stsprojectId) {
      edges {
        node {
          id
          stsbox {
            id
            plNumber
            location
            contents
          }
        }
      }
    }
  }
`;

function StsBoxes({ projectId, onAdd, allowEdit }) {
  const [showStsBoxesModal, setShowStsBoxesModal] = React.useState(false);

  const {data, refetch} = useQuery(GetStsBoxes, {
    variables: {
      stsprojectId: projectId,
      sortBy: ['created desc']
    },
    onError(e) {
      console.log(e);
    }
  });

  const [executeArchiveStsProjectEquipment, { loading: archiveLoading }] = useMutation(ArchiveStsProjectEquipment, {
    onCompleted() {
      refetch();
    }
  });

  function addStsBox() {
    setShowStsBoxesModal(true);
  }

  function removeStsBox(equipmentId) {
    executeArchiveStsProjectEquipment({
      variables: {
        input: {
          stsprojectEquipmentId: equipmentId,
        }
      }
    })
  }

  const projectEquipments = data ? data.stsprojectEquipments.edges.map(r => r.node).filter(r => !!r.stsbox) : [];
  const addedStsBoxes = projectEquipments.map(r => r.stsbox.id);

  return (
    <StyledBlock title={<BlockTitle><STSBoxIcon style={{ marginRight: '8px'}} /> Sts boxes</BlockTitle>}>
      <TableContainer>
        <Table aria-label="simple table" style={{ whiteSpace: 'nowrap' }}>
          <TableHead>
            <TableRow>
              <TableCell>
                PL Nr.
              </TableCell>
              <TableCell>
                Location
              </TableCell>
              <TableCell>
                Contents
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
          {
              !projectEquipments.length
                ? <TableRow>
                    <TableCell>None added</TableCell>
                    <TableCell />
                    <TableCell />
                    <TableCell />
                  </TableRow>
                : (
                  projectEquipments.map(equipment => (
                    <TableRow key={equipment.id}>
                      <TableCell>
                        <Link href={`/dashboard/equipment/stsBoxes/${equipment.stsbox.id}`} target="_blank">{equipment.stsbox.plNumber}</Link>
                      </TableCell>
                      <TableCell>
                        {equipment.stsbox.location}
                      </TableCell>
                      <TableCell style={{ maxWidth: '300px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                        {equipment.stsbox.contents}
                      </TableCell>
                      <TableCell align="right">
                        {
                          allowEdit && (
                            <IconButton
                              onClick={() => removeStsBox(equipment.id)}
                              aria-label="delete stsBox"
                              className="deleteButton"
                              disabled={archiveLoading}
                            >
                              <TrashIcon />
                            </IconButton>
                          )
                        }
                      </TableCell>
                    </TableRow>
                  ))
                )
            }
          </TableBody>
        </Table>
      </TableContainer>
      {
        allowEdit && (
          <ButtonWrapper>
            <Button
              variant="outlined"
              color="primary"
              onClick={addStsBox}
              endIcon={<AddIcon />}
            >
            Add STS box
            </Button>
          </ButtonWrapper>
        )
      }
      { showStsBoxesModal && <StsBoxesModal setShowStsBoxesModal={setShowStsBoxesModal} projectId={projectId} refetch={refetch} addedStsBoxes={addedStsBoxes} onAdd={onAdd} /> }
    </StyledBlock>
  );
}

const BlockTitle = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.textColor};
`;

const StyledBlock = styled(Block)`
  width: 1080px;
  max-width: 100%;
  margin-bottom: 16px;
`;

const Link = styled.a`
  color: ${props => props.theme.colors.primaryColor};
  text-decoration: none;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;

  @media (${props => props.theme.breakpoints.tablet}) {
    justify-content: flex-start;
  }
`;

export default StsBoxes;
